import { View, Text, TouchableOpacity } from 'react-native'
import React, { ReactNode, useEffect, useState } from 'react'
import { ZenIcon, ZenToast } from 'zen-core-elements'
import { CustomModal } from '../../../shared/commonComponents/customModal'
import { useAppDispatch, useAppSelector } from '../../../redux/hooks'
import { shallowEqual } from 'react-redux'
import { MobileBarcodeScanner } from '../../sellScreen/sellScreenCheckout/mobileBarcodeScanner'
import { ThemeConsumer } from '@rneui/themed'
import PermissionServices from '../../../shared/services/permissionService'
import { setBarcodeValue } from '../../../redux/slices/commonSlice'

const MobileScanner = ({ ui }: { ui?: ReactNode }) => {
	const isLandscape = useAppSelector((state) => state?.common?.isLandscape, shallowEqual)
	//variable to handle scanner modal
	const [scannerVisibleModal, setScannerVisibleModal] = useState(false)
	const dispatch = useAppDispatch()
	const checkCameraPermission = async () => {
		await PermissionServices?.cameraAccessPermission().then(async (response) => {
			if (response) {
				setScannerVisibleModal(true)
			}
		}).catch(() => {
			ZenToast({
				type: "error",
				message: "Failed to scan a barcode"
			})
		})
	}

	return (
		<ThemeConsumer>
			{({ theme }) => (
				<>
					{ui ?
						React.isValidElement(ui) &&
						React.cloneElement(ui as React.ReactElement, {
							onPress: checkCameraPermission,
						} as any)
						:
						< TouchableOpacity style={{
							width: 40,
							height: 40,
							backgroundColor: theme?.light,
							borderRadius: 12,
							justifyContent: 'center',
							alignItems: 'center',
							elevation: 2,
							shadowColor: '#000',
							shadowOpacity: 0.05,
							shadowOffset: { width: 0, height: 2 },
							shadowRadius: 5,
						}}
							onPress={checkCameraPermission}
						>
							<ZenIcon name="qrcode" type="material-community" color={theme.lightDark} size={22} />
						</TouchableOpacity>}

					<CustomModal visible={scannerVisibleModal} onRequestClose={() => { setScannerVisibleModal(false) }} animationType="slide" transparent={true} statusBarTranslucent>
						<View style={{ flex: 1, justifyContent: "center", alignItems: "center", backgroundColor: theme.transparentBackground, overflow: "hidden" }}>
							<View style={[isLandscape ? { width: "50%", height: "80%" } : { width: "80%", height: "50%" }, { borderRadius: 10, overflow: "hidden" }]}>
								<View style={{ position: "absolute", zIndex: 10, right: 15, top: 15 }}>
									<TouchableOpacity onPress={() => setScannerVisibleModal(false)}>
										<ZenIcon name="close-circle" type="material-community" size={26} color={theme.light} />
									</TouchableOpacity>
								</View>
								<MobileBarcodeScanner
									setScannerVisibleModal={setScannerVisibleModal}
									setScannerValue={(val) => dispatch(setBarcodeValue(val))}
								/>
							</View>
						</View>
					</CustomModal>
				</>
			)
			}
		</ThemeConsumer >
	)
}

export default MobileScanner